import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Commands, Results } from '@local/client-contracts';
import { ManualPromise } from '@local/common';
import { ResultBulletPartComponent } from './result-bullet-part/result-bullet-part.component';
import { isEqual } from 'lodash';
import { WorkspacesService } from 'src/app/bar/services';

@Component({
  selector: 'result-bullet',
  templateUrl: './result-bullet.component.html',
  styleUrls: ['./result-bullet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultBulletComponent implements AfterViewInit {
  private readonly BULLET_GAP = 9;
  private readonly BULLET_COUNTER_WIDTH = 16;
  private afterViewInitPromise: ManualPromise<void> = new ManualPromise();
  _maxBulletWidth: number;
  bulletPartLimit: number;
  truncate: boolean = true;

  @Input() showDivider: boolean;
  @Input() fallback: string;
  @Input() highlights: Array<string>;
  @Input() set maxBulletWidth(val: number) {
    this._maxBulletWidth = val;
    this.setBulletLimit();
  }
  _model: Results.Bullet;
  @Input() set model(v: Results.Bullet) {
    if (!v || isEqual(this._model, v)) {
      return;
    }
    this._model = v;
  }
  get model() {
    return this._model;
  }

  get maxBulletWidth(): number {
    return this._maxBulletWidth;
  }
  @Output() invoke = new EventEmitter<Commands.Command>();

  constructor(
    private cdr: ChangeDetectorRef,
    private workspaceService: WorkspacesService
  ) {}

  ngAfterViewInit(): void {
    this.afterViewInitPromise.resolve();
    if (!this.fallback) {
      this.fallback = this.workspaceService.getLogo()?.lightUrl;
    }
  }

  @ViewChild('bullet', { read: ElementRef }) bulletRef: ElementRef;
  @ViewChildren('bulletPart', { read: ResultBulletPartComponent }) bulletPartRef: QueryList<ResultBulletPartComponent>;

  onInvoke(command: Commands.Command): void {
    if (!command) {
      return;
    }

    this.invoke.emit(command);
  }

  private async setBulletLimit(): Promise<void> {
    await this.afterViewInitPromise;
    this.bulletPartLimit = this.model?.parts?.length;
    this.cdr.markForCheck();
    if (this.bulletPartLimit > 1) {
      setTimeout(() => {
        this.setBulletPart();
      }, 0);
    }
  }

  private setBulletPart(): void {
    if (!this.bulletPartRef?.toArray() || !this.maxBulletWidth) {
      return;
    }

    const bulletsPartRef = this.bulletPartRef?.toArray();
    this.bulletPartLimit = 0;
    let width = 0;
    bulletsPartRef.forEach((part: ResultBulletPartComponent) => {
      width += part.bullet?.nativeElement?.offsetWidth + this.BULLET_GAP;
      if (width <= this.maxBulletWidth - this.BULLET_COUNTER_WIDTH) {
        this.bulletPartLimit++;
      }
    });
    this.truncate = false;
    this.cdr.markForCheck();
  }
}
